import { notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType } from '@types'

import { UpdateCommercialSupplierPayload, updateCommercialSupplier } from './api'

type UpdateVars = { id: number; payload: UpdateCommercialSupplierPayload }

const useUpdateCommercialSupplier = (onClose: () => void) => {
  const { t } = useTranslation()
  const tPrefix = 'commercial_users.use_update.'

  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(
    ({ id, payload }: UpdateVars) => updateCommercialSupplier(id, payload),
    {
      onSuccess: () => {
        notification.success({
          message: t(`${tPrefix}SUCCESS`),
        })
        queryClient.invalidateQueries(QUERY_KEYS.COMMERCIAL_SUPPLIERS)
        queryClient.invalidateQueries(QUERY_KEYS.COMMERCIAL_SUPPLIER_DETAIL)
        onClose()
      },
      onError: (err: unknown) => {
        const axiosError = err as AxiosErrorType
        if (axiosError?.data?.error) {
          notification.error({
            message: t(`${tPrefix}ERROR`),
          })
        } else {
          console.error('Error:', axiosError)
        }
      },
    },
  )

  const updateCommercialSupplierById = (
    commercialSupplierId: number,
    payload: UpdateCommercialSupplierPayload,
  ) => mutate({ id: commercialSupplierId, payload })

  return {
    updateCommercialSupplier: updateCommercialSupplierById,
    isLoadingUpdateCommercialSupplier: isLoading,
  }
}

export { useUpdateCommercialSupplier }
